

export function formatPhoneNumber(input:string) {
  let cleaned = input?.replace(/^\++/, '+')?.replace(/[^\d+]/g, '');

  // Ensure it starts with '+', otherwise assume no country code
  if (!cleaned.startsWith('+')) {
    throw new Error("Phone number must include a country code (e.g. +44, +256, +1).");
  };

  // Extract country code (digits immediately after +)
  const match = cleaned.match(/^\+(\d{1,3})(\d*)$/);
  if (!match) { 
    throw new Error("Invalid phone number format.");
  }

  let countryCode = match[1];
  let localNumber = match[2].replace(/^0+/, ''); // remove leading zeros

  // Break local number into groups of 3 digits
  let parts = localNumber.match(/.{1,3}/g) || [];

  // Join with spaces
  return `+${countryCode} ${parts.join(' ')}`;
}
